module.exports = __webpack_public_path__ + "static/media/fail-ice-cream.2ce01404.svg";